<template>
  <v-main>
    <DetailsDialog ref="dialog" @reload="$refs.report.reload()" />

    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      @rowClicked="selectRow"
      :selectable="true"
      @update:selected="(v) => (selectedIds = v)"
      :rememberLastClick="true"
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn color="primary" @click="newRow">
          Novo dicionário CAN...
        </v-btn>
        <OMenuButton :menuOpts="menuOpts" />
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import { CANDict } from '@/models'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import DetailsDialog from './DetailsDialog.vue'
import { brDt } from 'oderon-commons/src/formatters.js'

export default {
  pageTitle: 'Dicionários CAN',
  components: {
    GenericReport,
    DetailsDialog
  },
  data() {
    return {
      reportSpec: {
        title: 'Dicionários CAN',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'sm',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar inativos',
            defVal: false
          }
        ]
      },
      adapterSpec: {
        defOrder: 'name asc',
        defCodes: ['id', 'name', 'variables', 'updatedAt', 'deletedAt'],
        columns: [
          { t: 'ID|', w: 70, d: 'id', color: '#cccccc' },
          { t: 'Nome', d: 'name' },
          {
            t: 'Variáveis',
            code: 'variables',
            w: 250,
            d: (row) => {
              return row.variables
                .filter((x) => !x.isInactive)
                .map((x) => x.code)
            }
          },
          { t: 'Baud Rate|', d: 'baudRate', selectable: true },
          { t: 'Send ACK|', d: 'sendAck', selectable: true },
          { t: 'Atualizado em|', d: 'updatedAt', f: brDt, w: 220 },
          { t: 'Desativado em|', d: 'deletedAt', f: brDt, w: 220 }
        ]
      },

      // checkboxes marcados (para duplicar)
      selectedIds: []
    }
  },
  computed: {
    menuOpts() {
      let len = this.selectedIds.length
      return [
        {
          text: 'Desativar...',
          onClick: () => this.confirmDelete(),
          disabled: len < 1
        },
        {
          text: 'Duplicar...',
          onClick: () => this.duplicate(),
          disabled: len !== 1
        }
      ]
    }
  },
  methods: {
    async fetchData({ keywords, includeInactive } = {}) {
      let { count, rows } = await CANDict.findAll({ keywords, includeInactive })
      return { count, rows }
    },

    async newRow() {
      let label = 'Digite o nome do novo dicionário'
      let name = await this.$prompt({ label })
      if (name != null) {
        let row = await this.$loading(async () => {
          return CANDict.save({ name })
        })
        this.$refs.report.reload()
        if (row != null) this.selectRow({ row })
      }
    },

    selectRow({ row }) {
      this.$refs.dialog.open(row.id)
    },

    async duplicate() {
      const sourceId = this.selectedIds[0]
      let oldRow = await CANDict.findById(sourceId)
      let label = 'Digite o nome do novo dicionário:'
      let value = oldRow.name + ' Cópia'
      let newName = await this.$prompt({ label, value })
      if (newName != null) {
        let row = await this.$rootLoading(async () => {
          return await CANDict.duplicate({ sourceId, newName })
        })
        this.$refs.report.reload()
        if (row != null) {
          this.selectRow({ row })
          this.$snack('Cópia criada com sucesso')
        }
      }
    },

    async confirmDelete() {
      let res = await this.$confirmDeactivate({
        strings: 'dicionário,dicionários;o',
        len: this.selectedIds.length
      })

      if (res) {
        this.$loading(async () => {
          for (let id of this.selectedIds) {
            await CANDict.delete(id)
          }
          this.selectedIds = []
          this.$snack('Desativado(s) com sucesso')
          this.$refs.report.reload()
        })
      }
    }
  }
}
</script>

<style></style>
